import { Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'orgbrain-snack-mess',
  templateUrl: './snack-mess.component.html',
  styleUrls: ['./snack-mess.component.scss'],
    standalone: false
})
export class SnackMessComponent implements OnInit {
  data = inject(MAT_SNACK_BAR_DATA);
  snack = inject(MatSnackBar);

  hasAction: boolean;
  constructor() {
    const data = this.data;

    this.hasAction = data.action;
  }

  ngOnInit() {}

  action() {
    this.snack.dismiss();
  }
}
